<template>
  <div class="home">
    <header>
      <div v-if="authenticated" class="user-header">
        <img class="user-avatar" src="../assets/logo.svg" />
        <h3>
          Hey {{ displayName }}, hope you are having a nice day.
          <span
            class="logout"
            @click="logout"
          >Logout</span>
        </h3>
      </div>
      <div class="app-header">
        <router-link to="/">
          <h1>recently</h1>
        </router-link>
        <div class="add-button">
          <router-link to="/add">
            <img src="../assets/add.svg" />
          </router-link>
        </div>
      </div>
    </header>
    <div v-if="this.$store.getters.getItems && this.$store.getters.getItems.length > 0">
      <div v-for="item in this.$store.getters.getItems.slice().reverse()" :key="item.id">
        <Card :item="item" :displayName="displayName"/>
      </div>
    </div>
  </div>
</template>

<script>
import { db } from "@/main";
import firebase from "firebase";
import Card from "@/components/Card";
import "vuejs-dialog/dist/vuejs-dialog.min.css";

export default {
  components: {
    Card
  },
  name: "home",
  metaInfo: {
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: "Recently",
    // all titles will be injected into this template
    titleTemplate: "%s | What are you enjoying"
    // link: [
    //   { rel: "favicon", href: "../assets/favicon.png" },
    //   { rel: "manifest", href: "../manifest.json" },
    //   { rel: "icon", type: "image/png", href: "./assets/favicon.png" }
    // ]
  },
  beforeCreate: function() {
    this.$store.dispatch("setItems");
  },
  created: function() {
    var self = this;
    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        var uid = firebase.auth().currentUser.uid;
        var docRef = db.collection("users").doc(uid);
        self.authenticated = uid;
        docRef.get().then(user => {
          if (user.exists) {
            let docData = user.data();
            let name = docData["name"];
            this.displayName = name;
          }
        });
      }
    });
  },
  data: function() {
    return {
      authenticated: "",
      myTitle: "",
      myFeeling: "",
      myAuthor: "",
      myCategory: "",
      myLink: "",
      errors: "",
      displayName: ""
    };
  },
  methods: {
    logout: function() {
      firebase
        .auth()
        .signOut()
        .then(() => {
          this.$router.replace("login");
        });
    }
  }
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

html {
  box-sizing: border-box;
}
*,
*:before,
*:after {
  box-sizing: inherit;
}

body {
  font-family: "Libre Franklin", sans-serif;
  font-weight: 100;
  background-color: #f2f2f2;
  color: #000;
  margin: 0;
  padding: 0;
  height: 100vh;
}

header {
  width: 75%;
  margin: 2em auto 0.5em;
}

.app-header,
.user-header {
  display: flex;
  align-items: center;
  flex-direction: row;
}

.add-button {
  margin-left: 10px;
  margin-top: 5px;
}

.user-avatar {
  margin-right: 10px;
  /* margin-top: 5px; */
}

.font-awesome-icon {
  cursor: pointer;
}

h1 {
  /* text-transform: uppercase; */
  font-weight: 600;
  font-size: 1.75em;
  /* margin-bottom: 0.3em;
  padding-top: 1em; */
}

h2 {
  margin-top: 0.5em;
  margin-bottom: 0.125em;
  line-height: 1.1em;
}

p {
  color: rgba(0, 0, 0, 0.5);
  margin-top: 0;
  margin-bottom: 0.25em;
  font-size: 1.25em;
}

a {
  /* color: rgba(0, 0, 0, 0.5); */
  color: #000;
  text-decoration: none;
}

.logout {
  text-decoration: underline;
  cursor: pointer;
}

section {
  margin: 0 auto;
  margin-bottom: 1.25em;
  color: #30323c;
  background-color: rgba(255, 255, 255, 1);
  padding: 1em;
  width: 75%;
  border-radius: 5px;
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.05);
  padding-bottom: 0.25em;
}
mark {
  background-color: rgba(0, 0, 0, 0.05);
  font-size: 0.75em;
  color: rgba(0, 0, 0, 1);
  padding: 4px 8px;
  border-radius: 5px;
  text-transform: uppercase;
}

aside {
  margin-bottom: 0.95em;
  text-transform: uppercase;
  font-size: 0.75em;
  color: rgba(0, 0, 0, 1);
  font-weight: bold;
}

.cardHeader {
  display: flex;
  /* font-size: 12px;
  font-weight: 400; */
  align-content: space-between;
  align-items: center;
}

.cardFooter {
  display: flex;
  font-size: 12px;
  font-weight: 400;
  align-content: space-between;
  align-items: center;
}

.left {
  flex: 4;
}

.right p {
  width: 50px;
  cursor: pointer;
}

.right {
  color: rgba(0, 0, 0, 0.5);
  text-align: right;
  /* flex: 1; */
  margin-left: auto;
}

.vue-moments-ago {
  font-size: 1em !important;
}

.dg-content-body {
  border-bottom: 1px solid #000;
  padding-bottom: 20px;
}

.dg-content {
  text-align: center;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
}

.dg-content-footer {
  padding: 10px 0;
}

.dg-btn {
  width: 175px;
  margin-bottom: 0;
  font-weight: 100;
}

.dg-btn--ok {
  border-color: #000;
  color: #000;
}

.dg-btn--cancel {
  background-color: #000;
}

@media only screen and (max-width: 600px) {
  /* body {
    background-color: #fff;
  } */

  header {
    width: 90%;
    margin: 0 auto;
  }

  section {
    margin: 0 auto;
    margin-bottom: 1.25em;
    color: #30323c;
    background-color: rgba(255, 255, 255, 1);
    padding: 1em;
    width: 90%;
    border-radius: 5px;
    box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.05);
  }
}
</style>
